// Analytics utility for tracking custom events
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-R2LTDQ51TH';

// Check if gtag is available (for development/testing)
const isGtagAvailable = () => {
  return typeof gtag !== 'undefined' && typeof window !== 'undefined';
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    gtag('event', eventName, {
      ...parameters,
      // Add timestamp for better tracking
      timestamp: new Date().toISOString(),
    });
  } else {
    // Log to console in development
    console.log('Analytics Event:', eventName, parameters);
  }
};

// Track page views (useful for SPA routing)
export const trackPageView = (pagePath, pageTitle) => {
  if (isGtagAvailable()) {
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

// Track RSVP form events
export const trackRSVPEvent = (eventType, data = {}) => {
  trackEvent('rsvp_interaction', {
    event_type: eventType,
    ...data,
  });
};

// Track photo gallery events
export const trackPhotoEvent = (eventType, photoData = {}) => {
  trackEvent('photo_interaction', {
    event_type: eventType,
    ...photoData,
  });
};

// Track language switching
export const trackLanguageChange = (fromLang, toLang) => {
  trackEvent('language_changed', {
    from_language: fromLang,
    to_language: toLang,
  });
};

// Track user engagement
export const trackEngagement = (action, section) => {
  trackEvent('user_engagement', {
    action: action,
    section: section,
  });
};

// Track errors (for debugging)
export const trackError = (error, context = {}) => {
  trackEvent('error_occurred', {
    error_message: error.message || error,
    error_stack: error.stack,
    ...context,
  });
};

// Predefined event types for consistency
export const EVENT_TYPES = {
  // RSVP Events
  RSVP_FORM_STARTED: 'rsvp_form_started',
  RSVP_FORM_COMPLETED: 'rsvp_form_completed',
  RSVP_FORM_ABANDONED: 'rsvp_form_abandoned',
  
  // Photo Events
  PHOTO_VIEWED: 'photo_viewed',
  PHOTO_GALLERY_OPENED: 'photo_gallery_opened',
  PHOTO_GALLERY_CLOSED: 'photo_gallery_closed',
  
  // Navigation Events
  SECTION_VIEWED: 'section_viewed',
  BUTTON_CLICKED: 'button_clicked',
  
  // Language Events
  LANGUAGE_CHANGED: 'language_changed',
  
  // Engagement Events
  SCROLL_DEPTH: 'scroll_depth',
  TIME_ON_PAGE: 'time_on_page',
};
